import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
} from "react-router-dom";
import RouteWrapper from "./RouteWrapper";
import LdapLogin from "./pages/LdapLogin";
// import Register from "./pages/Old_Register";
import Chat from "./pages/Chat_v2";
// import RegisterResult from "./pages/RegisterResult";
import Policy from "./pages/Policy";
import PolicyForApp from "./pages/PolicyForApp";
// import Faq from "./pages/Faq";
import Test from "./pages/Test";
import Example from "./pages/Example";
import VideoUnderstanding from "./pages/VideoUnderstanding";
import Notice from "./pages/Notice";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RouteWrapper />,
    children: [
      {
        path: "/",
        element: <Chat />,
      },
      // {
      //   path: "/login",
      //   element: <Navigate to="/" replace />,
      // },
      {
        path: "/ldap",
        element: <LdapLogin />,
      },
      {
        path: "/videoUnderstanding",
        element: <VideoUnderstanding />,
      },
      // {
      //   path: "/videoEditor3",
      //   element: <VideoEditor3 />,
      // },
      {
        path: "/notice",
        element: <Notice />,
      },
      {
        path: "/policy",
        element: <Policy />,
      },
      {
        path: "/policyForApp",
        element: <PolicyForApp />,
      },
      {
        path: "/wb/policyForApp",
        element: <PolicyForApp />,
      },
      {
        path: "/test",
        element: <Test />,
      },
      {
        path: "/example",
        element: BUSINESS_ENV.indexOf("prod") > -1 ? <Chat /> : <Example />,
      },
      {
        path: "/qa/:id",
        element: <Chat />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
